import ApiCore from '@/api/api-core'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class SystemSettingGeneral extends ApiCore {
  constructor(store) {
    const path = `${ACTIVE_BASE_REST}/setting/general`
    super(store, path)
  }

  get(showProgress) {
    return this._request({
      method: 'GET',
      showProgress
    })
  }

  update(model, showProgress) {
    return this._request({
      method: 'PUT',
      body: model,
      showProgress
    })
  }
}
